export enum AppGoalsCubeMetric {
  TimeInApp = 'TimeInApp',
  Interactions = 'Interactions',
  CallTimeInApp = 'CallTimeInApp',
  CalendarTimeInApp = 'CalendarTimeInApp',
  Score = 'Score',
}
